import { useCallback } from 'react';
import { string } from 'prop-types';
import {
  history as historyPropType,
  location as locationPropType,
} from 'react-router-prop-types';

import Modal from '../components/utility/Modal/Modal';
import Layout from '../components/styled/Layout/Layout';
import Content from '../components/styled/Content/Content';
import GlossaryRoutes from 'components/Glossary/GlossaryRoutes';

/**
 * GlossaryModal is the layout for the Glossary when we open it up in
 * a modal state. The modal state itself is triggered by setting
 * {modal: true} as state in a React Router or Anchor link's to state object.
 *
 * It's possible this Layout component can be refactored in one Glossary
 * component eventually, as soon as we documented and cleaned up everything.
 */
const GlossaryModal = ({ history, previousLocation, modalOptions }) => {
  window.history.replaceState(null, null, previousLocation.pathname);
  const back = useCallback(
    (event) => {
      if (event) event.stopPropagation();
      history.push({ ...previousLocation });
    },
    [history, previousLocation]
  );

  return (
    <Content>
      <Layout.MaxWidth>
        <Modal
          margin={'5em 15px'}
          alignSelf={'start'}
          hide={back}
          openFromSide={modalOptions.openFromSide}
        >
          <GlossaryRoutes
            modal
            hide={back}
            openFromSide={modalOptions.openFromSide}
          />
        </Modal>
      </Layout.MaxWidth>
    </Content>
  );
};

GlossaryModal.propTypes = {
  /** Which route should the modal go back to once we close the modal? */
  previousLocation: locationPropType.isRequired,
  history: historyPropType.isRequired,
  modalOptions: string,
};

export default GlossaryModal;
